import React, {
  useState,
  useCallback,
  useEffect,
} from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {
  AccessKeyViewModel,
} from '../../api/axcloud';

export interface EditAccessKeyDialogProps {
  editingAccessKey: AccessKeyViewModel | null;
  onCancel: () => void;
  onSubmit: (accessKey: AccessKeyViewModel, name: string) => void;
}

export function EditAccessKeyDialog({
  editingAccessKey,
  onCancel,
  onSubmit,
}: EditAccessKeyDialogProps) {
  const [name, setName] = useState("");
  const handleCancel = useCallback(() => {
    onCancel();
    setName("");
  }, [onCancel]);
  const handleSubmit = useCallback(() => {
    onSubmit(editingAccessKey!, name);
    setName("");
  }, [name, onSubmit, editingAccessKey]);
  useEffect(() => {
    setName(editingAccessKey?.name || "");
  }, [editingAccessKey]);

  return (
    <Dialog
      open={!!editingAccessKey}
      onClose={handleCancel}>
      <DialogTitle>アクセスキー編集</DialogTitle>
      <DialogContent>
        <DialogContentText>
        </DialogContentText>
        <TextField
          label="名前"
          type="text"
          required
          margin="dense"
          fullWidth
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
          />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={!name || name.length === 0}
        >
          変更
        </Button>
        <Button onClick={handleCancel}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
}
